
import { API_ENDPOINTS } from './api-endpoints';
import { crudFactory } from './curd-factory';
import { HttpClientFront } from './http-client-front';


export const getForumDetails = {
  
  ...crudFactory(API_ENDPOINTS.INDICES),
  get:({    
    ...params 
  }) => {    
    return HttpClientFront.get(`user_forum_data`, {
      ...params,
      
    });
  },
  
};

export const getUserScreens = {
  
  ...crudFactory(API_ENDPOINTS.INDICES),
  get:({    
    ...params 
  }) => {    
    return HttpClientFront.get(`user_screens`, {
      ...params,
      
    });
  },
};

export const getUserFollowScreens = {
  
  ...crudFactory(API_ENDPOINTS.INDICES),
  get:({    
    ...params 
  }) => {    
    return HttpClientFront.get(`get_followed_screens`, {
      ...params,
      
    });
  },
};

export const getUserDashboardStats = {
  
  ...crudFactory(API_ENDPOINTS.INDICES),
  get:({    
    ...params 
  }) => {    
    return HttpClientFront.get(`user_dashboard_stats`, {
      ...params,
      
    });
  },
};

export const deleteScreen = (id) => {
  return HttpClientFront.post(`/delete_user_screen/${id}`);
};